import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import {
  addAssetCategory,
  getAssetCategories,
} from '../../../Services/AssetManagement/AssetCategoryService';
import AssetCategoryForm from "../../../Components/Forms/Pages/AssetManagement/AssetCategory/AssetCategoryForm";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: true}
}

const AddAssetCategory = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [parents, setParents] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.assetManagement.assetCategory.addAssetCategory.pageTitle);
    });

    useEffect(() => {
        fetchAssetCategories(); 
    },[])

    const fetchAssetCategories = (term='') => {
        getAssetCategories({term}).then((response) => {
          if (!response || !response.ok) {
            return;
          }
          setParents(response.data.result);
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        addAssetCategory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <AssetCategoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                parents={parents}
                errors={errors} data={data} form={form} control={control}
                onParentChangeFilter={fetchAssetCategories}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddAssetCategory;